import React from 'react';
import { Box, Container, Typography, useTheme } from '@mui/material';

const Footer = () => {
    const theme = useTheme();

    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: theme.palette.background.paper,
                borderTop: `1px solid ${theme.palette.border.main}`,
                padding: theme.spacing(2),
                mt: 6,
            }}
        >
            <Container maxWidth="xl" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2" color="text.secondary">
                    © {new Date().getFullYear()} TravelCRM. Wszelkie prawa zastrzeżone.
                </Typography>

                <Typography variant="body2" color="text.secondary">
                    Wersja systemu: 1.0.0
                </Typography>
            </Container>
        </Box>
    );
};

export default Footer;
